/**
 * Transition Component
 *
 * Lightweight page enter animation (replaces react-transition-group to avoid
 * findDOMNode warnings under React 18 StrictMode).
 */

import React from 'react'

class Transition extends React.PureComponent {
  render() {
    const { children, location } = this.props
    return (
      <div key={location.pathname + location.hash} className="page-transition">
        {children}
      </div>
    )
  }
}

export default Transition
